<div class="page">

  <div class="page_header">
    <h1 class="page_title">Gerenciar loja</h1>
    <div class="page_action" style="gap: 20px">
      <a href="javascript:void(0);" (click)="actionAward()" class="page_action_excel btn btn-warning" type="button">
        <svg-icon src="assets/svg/plus-circle.svg"></svg-icon>
        <span class="ml-2 font-weight-normal">Criar novo produto</span>
      </a>

    </div>
  </div>

  <div class="page_padding">
    <div class="table-responsive">
      <table class="table table_regular">
        <thead>
          <tr>
            <th scope="col" class="w-10"></th>
            <th scope="col">Foto</th>
            <th scope="col">Nome</th>
            <th scope="col">Estoque</th>
            <th scope="col">Categoria</th>
            <th scope="col">Reservado</th>
            <th scope="col">Valor</th>
            <th scope="col">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="isNullOrUndefined(productsList)">
            <td colspan="10" class="text-center" style="padding: 68px 0 !important;"> nenhum registro encontrado
            </td>
          </tr>
          <tr *ngFor="let product of productsList">
            <td style="width: 150px">
              <div class="d-flex justify-content-center" style="gap: 15px">
                <svg-icon class="is-cursor" src="assets/svg/edit.svg" (click)="changeAward(product)"></svg-icon>
                <svg-icon class="is-cursor" src="assets/svg/close-circle.svg"
                  (click)="deleteProduct(product)"></svg-icon>
              </div>
            </td>
            <td>
              <div class="product-photo-container">
                <img style="width: 50px; height: 50px;" *ngIf="product.image" [src]="bucketUrl + product.image" alt=""
                  (click)="expandImage(product?.image)">
              </div>
            </td>
            <td>
              {{product?.name}}
            </td>
            <td>
              {{product?.quantity}} {{product?.quantity > 1 ? 'unidades' : 'unidade'}}
            </td>
            <td>
              {{product?.category}}
            </td>
            <td>
              {{product?.reserved || 0}}
            </td>
            <td>
              {{product?.value}} {{product?.value > 1 ? 'pontos' : 'ponto'}}
            </td>
            <td>
              <div class="status-container">
                {{product?.status ? 'Ativo' : 'Inativo'}}
                <span [ngClass]="{'green': product?.status, 'red': !product?.status}" class="status"></span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="modal-custom modal fade" id="modalAward" data-keyboard="false" data-backdrop="static" role="dialog"
  aria-labelledby="modalNoteResumeLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 560px" role="document">
    <div class="modal-content modal-user">
      <div class="modal-header">
        <h2 class="modal-user_title">{{'challenge' | translate}}</h2>
        <a data-dismiss="modal" class="modal_close" aria-label="Close">
          <svg-icon src="assets/svg/close-modal.svg"></svg-icon>
        </a>
      </div>
      <div class="modal-user_body">
        <div class="modal-user_card">
          <fieldset class="custom__form" autocomplete="off">
            <div class="row">
              <div class="col-xs-12 col-md-12">
                <div class="row">
                  <div class="col-12 col-md-12">
                    <div class="input-material custom__input modal_text_input">
                      <input id="iptName" class="form-control" name="name" type="text" [(ngModel)]="modelAward.name"
                        required />
                      <label for="iptName">{{ "storeManagement.awardName" | translate}}</label>
                    </div>
                  </div>
                  <div class="col-12 col-md-12">
                    <div class="input-material input-image">
                      <label for="awardImage">
                        <img src="assets/svg/upload.svg" alt="" width="110" height="110">
                        <p> <span>{{ "Browse" | translate }}</span> {{ "storeManagement.uploadImage" | translate }}</p>
                      </label>
                      <input type="file" id="awardImage" name="awardImage" (change)="onImageChange($event)"
                        placeholder="Insira Imagem" required>
                      <div id="image-selected-container" *ngIf="awardImage">
                        <img [src]="awardImage" alt="Imagem Selecionada">
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-12">
                    <div class="input-material custom__input modal_text_input">
                      <input id="iptValue" maxlength="6" max="999999" class="form-control" name="value" type="number"
                        [(ngModel)]="modelAward.value" (input)="onValueChange($event, 'value')" required />
                      <label for="iptValue">{{ "storeManagement.awardValue" | translate}}</label>
                    </div>
                  </div>
                  <div class="col-12 col-md-12">
                    <div class="input-material custom__input modal_text_input">
                      <input id="iptQuantity" maxlength="6" max="999999" class="form-control" name="quantity"
                        type="number" [(ngModel)]="modelAward.quantity" (input)="onValueChange($event, 'quantity')"
                        required />
                      <label for="iptQuantity">{{ "storeManagement.awardQuantity" | translate }}</label>
                    </div>
                  </div>
                  <div class="col-12 col-md-12">
                    <div class="input-material custom__input modal_text_input">
                      <input id="iptCategory" class="form-control" name="category" type="text"
                        [(ngModel)]="modelAward.category" required />
                      <label for="iptCategory">{{ "storeManagement.category" | translate}}</label>
                    </div>
                  </div>
                  <div class="col-12 col-md-12">
                    <div class="box-switch">
                      <span>{{this.modelAward.status ? 'Ativo' : 'Inativo' }}</span>
                      <label class="switch mb-0">
                        <input type="checkbox" name="checkbox" [(ngModel)]="modelAward.status"
                          class="ng-untouched ng-pristine ng-valid">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </div>
                  <div class="col-12">
                    <a class="btn btn-block btn-lg btn-primary text-warning" href="javascript:void('save');"
                      (click)="actionSave()">
                      <div *ngIf="newloading; else elseBlock" class="spinner-border" role="status"></div>
                      <ng-template #elseBlock>
                        {{ "save" | translate }}
                      </ng-template>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="expandedImageUrl" class="backdrop" (click)="closeExpandedImage()">
  <div class="image-modal">
    <img [src]="expandedImageUrl" alt="Expanded Image" />
  </div>
</div>